import { observable, decorate, action } from 'mobx'
import axios from 'axios'

class SendMailStore {
  constructor (rootStore) {
    this.state = {
      subject: '',
      body: '',
      selectedProducts: [],
      selectedCompanies: [],
      isSending: false
    }

    this.stores = rootStore.stores
  }

  handleChange (value, name) {
    this.state[name] = value
  }

  setSelectedProducts (selectedProducts) {
    this.state.selectedProducts = selectedProducts.map(data => data.value)
  }

  setSelectedCompanies (selectedCompanies) {
    console.log(selectedCompanies)
    this.state.selectedCompanies = selectedCompanies
  }

  sendMail () {
    this.state.isSending = true
    const url = process.env.REACT_APP_AWS_URL + '/sendCustomEmail/'
    axios.post(url, {
      products: this.state.selectedProducts,
      companies: this.state.selectedCompanies.map(data => data.value),
      body: this.state.body,
      subject: this.state.subject
    })
    .then(response => {
      console.log(response)
      if (response.data.status === 'ok') {
        this.stores.notificationStore.sendSuccessNotification('Pronto!', 'E-mail enviado com sucesso')
      } else {
        this.stores.notificationStore.sendErrorNotification('Ops!', `Ocorreu um erro: ${response.data.msg}`)
      }
      this.state.isSending = false
    })
    .catch(error => {
      console.log(error)
      this.stores.notificationStore.sendErrorNotification('Ops!', `Ocorreu um erro: ${error.message}`)
      this.state.isSending = false
    })
  }
}

decorate(SendMailStore, {
  state: observable
})

export default SendMailStore



// WEBPACK FOOTER //
// ./src/stores/sendMailStore.js